export default __webpack_public_path__ + "static/media/Spotify_Icon_RGB_White.ecd54051.png";